import { render, staticRenderFns } from "./one.vue?vue&type=template&id=dbd3bc90&scoped=true&"
import script from "./one.vue?vue&type=script&lang=js&"
export * from "./one.vue?vue&type=script&lang=js&"
import style0 from "./one.vue?vue&type=style&index=0&id=dbd3bc90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd3bc90",
  null
  
)

export default component.exports